import { createNode } from '@glueapp/graph-types';

export const CreateListOfCopies = createNode({
    id: 'Create List of Copies',
    name: 'Create List of Copies',
    description: 'Creates a list of copies of the value to copy and with length of the length input',
    aiDescription:
        'Creates a list by deep-cloning a single value N times. Set "Length of List" (number) and "Value to copy" (any type). Output: "List of copies".',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        'Length of List': { kind: 'number' },
        'Value to copy': { kind: 'generic', identifier: 'T' },
    },
    outPorts: {
        'List of copies': {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
    },
    execute: function (input) {
        const length = input.inPorts['Length of List'];
        const valueToCopy = input.inPorts['Value to copy'];
        const stringVersionOfValue = JSON.stringify(valueToCopy);
        return { output: { 'List of copies': Array.from({ length }, () => JSON.parse(stringVersionOfValue)) } };
    },
});
